<template>
  <router-link
    :to="to"
    active-class="text-action"
    class="hover:text-action flex-auto"
  >
    <div
      class="flex flex-col text-center cursor-pointer px-1 md:px-5 items-center"
    >
      <span class="pb-2 flex items-center">
        <font-awesome-icon size="lg" :icon="icon"></font-awesome-icon
      ></span>
      <span class="whitespace-no-wrap overflow-x-hidden"><slot /></span>
    </div>
  </router-link>
</template>

<script>
export default {
  props: ["to", "icon"],
};
</script>
